import { createContext, useContext, useState, useEffect } from 'react'
import api from '../utils/api'

const AuthContext = createContext()

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem('token')
      if (token) {
        await fetchUser()
      } else {
        setLoading(false)
      }
    }
    initAuth()
  }, [])

  const fetchUser = async () => {
    try {
      const response = await api.get('/auth/me')
      if (response.data.success) {
        setUser(response.data.user)
        return response.data.user
      }
    } catch (error) {
      // 静默处理 502/503 错误（后端服务不可用）
      if (error.response?.status === 502 || error.response?.status === 503) {
        console.warn('后端服务暂时不可用，跳过用户信息获取')
        // 如果有 token，保持登录状态（不跳转到登录页）
        const token = localStorage.getItem('token')
        if (token) {
          // 设置一个临时用户对象，避免被重定向到登录页
          setUser({ id: 'temp', nickname: '用户', level: 1 })
        }
      } else {
        console.error('获取用户信息失败:', error)
      }
      
      // 只有 401 错误才清除 token
      if (error.response?.status === 401) {
        localStorage.removeItem('token')
        setUser(null)
      }
    } finally {
      setLoading(false)
    }
  }

  const login = async (phone, code) => {
    try {
      const response = await api.post('/auth/login', { phone, code })
      if (response.data.success) {
        localStorage.setItem('token', response.data.token)
        setUser(response.data.user)
        await fetchUser()
        return response.data
      }
      throw new Error(response.data.error || '登录失败')
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        throw new Error(error.response.data.error)
      }
      throw error
    }
  }

  const logout = () => {
    localStorage.removeItem('token')
    setUser(null)
  }

  const getLevelName = (level) => {
    const names = {
      1: '新手',
      2: '初级',
      3: '中级',
      4: '高级',
      5: '专家',
      6: '大师'
    }
    return names[level] || '新手'
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, getLevelName, fetchUser }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider')
  }
  return context
}
